import React from "react";
import "../../../../styles/managementTheme.css";
import "../styles/bonificaciones.css";

const SummaryCard = ({ label, value, icon, accent = "secondary", active, onClick }) => (
  <div className="w-100">
    <div
      className={`management-stat-card bonificaciones-summary-card h-100 ${accent ? `accent-${accent}` : ""} ${
        active ? "active" : ""
      }`}
      role="button"
      tabIndex={0}
      onClick={onClick}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          onClick?.();
        }
      }}
    >
      <div className="management-stat-icon">
        <i className={`bi ${icon}`} />
      </div>
      <div>
        <p className="management-stat-label mb-1">{label}</p>
        <div className="management-stat-value">{value}</div>
      </div>
    </div>
  </div>
);

export default function BonificacionesSummary({ resumen, onQuickFilter, activeKey }) {
  return (
    <div className="management-card mb-4">
      <div className="bonificaciones-summary-grid">
        <SummaryCard
          label="Bonificaciones"
          value={resumen.total || 0}
          icon="bi-coin"
          accent="primary"
          active={activeKey === "total"}
          onClick={() => onQuickFilter?.("total")}
        />
        <SummaryCard
          label="Pendientes"
          value={resumen.pendientes || 0}
          icon="bi-hourglass-split"
          accent="warning"
          active={activeKey === "pendiente"}
          onClick={() => onQuickFilter?.("pendiente")}
        />
        <SummaryCard
          label="No Pagadas"
          value={resumen.no_pagadas || 0}
          icon="bi-exclamation-circle"
          accent="danger"
          active={activeKey === "no_pagada"}
          onClick={() => onQuickFilter?.("no_pagada")}
        />
        <SummaryCard
          label="Pagadas"
          value={resumen.pagadas || 0}
          icon="bi-check-circle"
          accent="success"
          active={activeKey === "pagada"}
          onClick={() => onQuickFilter?.("pagada")}
        />
        <SummaryCard
          label="Anuladas"
          value={resumen.anuladas || 0}
          icon="bi-x-circle"
          accent="secondary"
          active={activeKey === "anulada"}
          onClick={() => onQuickFilter?.("anulada")}
        />
      </div>
    </div>
  );
}
